export default function(state: any) {
  const { currentProjectId, projects } = state.user;
  const currentProject = projects.filter((project: any) => project.id === currentProjectId);
  if (typeof currentProject[0] === 'undefined') {
    return [];
  }
  const { permissions } = currentProject[0];
  return permissions;
}
